import MoreActionsDropdownMobile from './MoreActionsDropdownMobile';
import MoreActionsDropdownMobileContainer from './MoreActionsDropdownMobile.container';

export default MoreActionsDropdownMobileContainer(MoreActionsDropdownMobile);
